import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MasterService } from '../../@core/services/master.service';
import { RoleService } from '../../@core/services/role.service';
import { ExportService } from '../../@core/services/export.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
  selector: 'ngx-part-info',
  templateUrl: './part-info.component.html',
  styleUrls: ['./part-info.component.scss']
})
export class PartInfoComponent implements OnInit {
  makeName: string = 'Select Make';

  makeDetails = [
    { id: 1, makeName: 'AMP' },
    { id: 2, makeName: 'TE Connectivity' },
    { id: 3, makeName: 'AERO' },
    { id: 4, makeName: 'Rotary' },
    { id: 5, makeName: 'ITT' },
  ];

  selectedManufacturer: string = "";
  filteredSourceInfoData: any[] = [];
  selectedRowIndex: number | null = null;
  modalRef: NgbModalRef | null = null;


  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  // selectedPriceData: any;

  selectedPriceData: any = null;

  sourceInfoData = [];
  project_id: any;
  projectName: any;
  version_id: number;
  userId: any;
  role: any;
  userRole: any;
  projectViewData = [];
  errorMessage: string;
  internalPartNo: any;
  rankedSellersDetails: any[];
  manufacturerDetails = [];
  part_header = [];
  // projectQty = [];
  projectQty: number = 0;
  description: any;
  dataSheet: any;
  selectedRow: number | null = null;
  MPN: any;
  mpnMatch: string;
  sessionMpnMatch: string;
  closeResult: string;
  offerPriceListDetails: any[];
  projectSupplierName: string = "";
  // selectedPriceRowIndex: number | null;
  selectedPriceRowIndex: number | null = null;


  customerInfoData: any;
  leadTimeFromHeader: number | null = null;
  commidityFromHeader: any;
  commodity: any; // <-- Add this line to declare the property
  criteria: any = {}
  preparedPartDetails: any[] = [];
  preparedQuery: string = '';


  showSpecsDetails = false;
  selectedSpecs: any[] = [];
  selectedPartDetails: any = {};
  cleanedResHTML: string = '';
  showPopup = false;
  showPopup1 = false;
  selectedSupplierData: any;
  projectStatus: string = '';
  cameFrom: string = 'part-info';



  savedFilter: string = 'all';

  @ViewChild('addPartModal') addPartModal: any;
  @ViewChild('offlineConfirmModal') offlineConfirmModal: any;
  partForm: FormGroup;
  // frequencyOptions: any[] = [];
  frequencyOptions: { id: number, scheduleType: string }[] = [];
  activeModal: NgbModalRef;
  offlineConfirmModalRef: NgbModalRef; // Add this line
  tempOfflineData: any; // Add this to store offline data temporarily
  ngOnInit() {
    this.project_id = sessionStorage.getItem('project_id');
    this.version_id = Number(sessionStorage.getItem('version_id'));
    this.projectName = sessionStorage.getItem('projectName');
    this.internalPartNo = String(sessionStorage.getItem('internalPartNo'));
    this.mpnMatch = String(sessionStorage.getItem('mpnMatch'));
    this.sessionMpnMatch = String(sessionStorage.getItem('mpnMatch'));
    this.commodity = String(sessionStorage.getItem('commodity') || '');



    this.projectStatus = sessionStorage.getItem('projectStatus') || '';


    // projectSupplierInfo
    console.log('version_id:', this.version_id);


    this.userId = sessionStorage.getItem('user_id'); // Retrieves session user_id
    this.role = sessionStorage.getItem('role');     // Retrieves role   
    console.log('User ID:', this.userId);
    console.log('Role:', this.role);


    let projectSupplierInfo = JSON.parse(sessionStorage.getItem('projectSupplierInfo') || '{}');

    this.projectSupplierName = projectSupplierInfo?.supplier || '';
    this.commodity = projectSupplierInfo?.commodity || '';

    console.log("Commodity from projectSupplierInfo:", this.commodity);

    console.log('projectSupplierInfo', projectSupplierInfo)

    this.getdata();
    this.userRole = this.roleService.getUserRole();
    this.partForm = this.f_builder.group({
      projectName: ['', Validators.required],
      internalPartNo: ['', Validators.required],
      MPN: ['', Validators.required],
      Make: [''],
      uom: ['', Validators.required],
      requiredQuantity: ['', [Validators.required, Validators.min(1)]],
      frequency: [null, Validators.required],
      sourcingType: this.f_builder.group({
        nexar: [false],
        vendor: [false],
        offline: [false]
      })
    });
    this.onSort(this.sortColumn);
    const navData: any = this.location.getState();
    if (navData?.internalPartNo) {
      this.internalPartNo = navData.internalPartNo;
      this.projectQty = navData.projectQty;
      this.getProcurementHistory();
    }
    if (navData?.fromProjectView) {
      this.cameFrom = 'project-view';
    }
    // this.savePriceData();
  }
  constructor(
    private router: Router,
    private modalService: NgbModal,
    private masterService: MasterService,
    private roleService: RoleService,
    private notify: NbToastrService,
    private exportService: ExportService,
    private actRoute: ActivatedRoute,
    private f_builder: FormBuilder,
    private location: Location
  ) {
    const navigation = this.router.getCurrentNavigation();
    console.log("navigation => ", navigation)
    if (navigation?.extras?.state) {
      this.customerInfoData = navigation.extras.state.customerInfo;
      let row = navigation.extras.state.row
      this.savedFilter = navigation.extras.state.savedFilter || 'all';

      console.log("Received Filter From Project-View:", this.savedFilter);

      if (navigation.extras.state.fromProjectView) {
        this.cameFrom = 'project-view';
      } else {
        this.cameFrom = 'part-info';
      }
    }


  }

  private getDismissReason(reason: any): string {
    if (reason === 'ESC') {
      return 'by pressing ESC';
    } else if (reason === 'BACKDROP_CLICK') {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.filteredSourceInfoData.sort((a, b) => {
      let valA = a[column];
      let valB = b[column];

      // Handle null/undefined and trim strings
      valA = valA !== undefined && valA !== null ? valA.toString().trim() : '';
      valB = valB !== undefined && valB !== null ? valB.toString().trim() : '';

      // Check if values are numbers
      const isNumber = !isNaN(valA) && !isNaN(valB);

      if (isNumber) {
        return this.sortDirection === 'asc'
          ? Number(valA) - Number(valB)
          : Number(valB) - Number(valA);
      }

      return this.sortDirection === 'asc'
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    });
  }


  getSortIcon(column: string) {
    if (this.sortColumn !== column) {
      return 'fa fa-sort'; // Default unsorted icon
    }
    return this.sortDirection === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down';
  }

  openAddPartModal() {
    this.activeModal = this.modalService.open(this.addPartModal, { size: 'xl' });
    this.getProjectPartDetails();
    this.getFrequencyOptions();

    this.partForm.get('projectName')?.disable();
    this.partForm.get('internalPartNo')?.disable();
    this.partForm.get('MPN')?.disable();
    this.partForm.get('uom')?.disable();
    this.partForm.get('requiredQuantity')?.disable();
    this.partForm.get('frequency')?.enable();
  }

  specification: string = '';


  getProjectPartDetails() {
    const data = {
      project_id: this.project_id,
      version_id: this.version_id,
      internalPartNo: this.internalPartNo
    };

    this.masterService.get_project_part_details_Top_N_Seller(data).subscribe((res: any) => {
      if (res?.results?.length > 0) {
        const partDetails = res.results[0].project_parts[0].part_details[0];
        const nexarOffers = partDetails.Top_N_Sellers.nexar || [];

        const offlineOffers = partDetails.Top_N_Sellers.offline || [];
        const vendorOffers = partDetails.Top_N_Sellers.vendor || [];


        const tableData = [];

        // Add nexar data with sourcingType = 'nexar'
        for (const offer of nexarOffers) {
          tableData.push({ ...offer, sourcingType: 'nexar' });
        }

        // Add offline data with sourcingType = 'offline'
        for (const offer of offlineOffers) {
          tableData.push({ ...offer, sourcingType: 'offline' });
        }
        for (const offer of vendorOffers) {
          tableData.push({ ...offer, sourcingType: 'vendor' });
        }

        // Set combined data for your table
        this.filteredSourceInfoData = tableData;

        // Patch other form values if needed
        const project = res.results[0].project;
        const partHeader = res.results[0].project_parts[0].part_header;


        // Extract first Nexar offer if exists
        const firstNexarOffer = partDetails.Top_N_Sellers.nexar?.[0] || {};
        this.specification = firstNexarOffer.specification || '';
        console.log("specification =>", this.specification)
        if (project && partHeader) {

          this.partForm.patchValue({
            projectName: res.results[0].project.projectName || '',
            internalPartNo: res.results[0].project_parts[0].part_header.internalPartNo || '',
            MPN: firstNexarOffer.MPN || '',
            Make: firstNexarOffer.manufacturer || '',  // Patch Make from manufacturer field
            uom: res.results[0].project_parts[0].part_header.uom || '',
            requiredQuantity: res.results[0].project_parts[0].part_header.projectQty || '',
            specification: firstNexarOffer.specification || '',


          });

        }
      }
    }, error => {
      console.error("Failed to load part data", error);
    });
  }



  getFrequencyOptions() {
    this.masterService.get_frequency().subscribe({
      next: (res) => {
        if (Array.isArray(res)) {
          this.frequencyOptions = res;
        }
      },
      error: (err) => {
        console.error("Error loading frequency options", err);
      }
    });
  }

  submitAddPart() {
    if (this.partForm.invalid) return;
    const newPart = this.partForm.getRawValue();
    const currentUser = JSON.parse(JSON.stringify(sessionStorage.getItem('userDetails')));
    const job_id = new Date().toISOString().replace(/[-:.TZ]/g, '').slice(0, 14);


    const sourcingGroup = this.partForm.get('sourcingType')?.value;
    const selectedSources = Object.keys(sourcingGroup).filter(
      key => sourcingGroup[key]
    );

    const partPayload = {
      project_id: Number(this.project_id),
      project_name: newPart.projectName || `TP-${this.project_id}`,
      version_id: String(this.version_id),  // FIX: keep it number
      job_id: job_id,
      internal_part_no: newPart.internalPartNo,
      mpn: newPart.MPN,
      uom: newPart.uom,
      project_qty: Number(newPart.requiredQuantity) || 0,
      frequency_id: Number(newPart.frequency?.id) || 0,  // FIX: number not string

      data: [
        {
          part_header: {
            internalPartNo: newPart.internalPartNo,
            customerPartNumber: newPart.customerPartNumber || "",
            description: newPart.description || "",
            commodity: newPart.commodity || "",
            mpn: newPart.MPN,
            uom: newPart.uom,
            projectQty: Number(newPart.requiredQuantity) || 0,
            iSourcing: "No",
            stockAvailability: 0,
            leadTime: 0,
            minimumPrice: 0,
            authorisedSuppliers: 0,
            suppliers: [],
            eau: 0
          },
          Parts: [
            {
              specification: newPart.MPN || "",
              // manufacturer: newPart.manufacturer ?? ""
              //   manufacturer: (newPart?.manufacturer && newPart.manufacturer !== "N/A")
              //     ? newPart.manufacturer
              //     : "undefined"
              // }
              manufacturer:
                newPart.Make && newPart.Make !== 'N/A' ? newPart.Make : 'undefined'
            }
          ]

        }
      ]

    };



    console.log('Submitting part payload:', partPayload);


    this.masterService.create_part_alert(partPayload).subscribe(
      (res: any) => {
        alert('Part created successfully!');
        this.activeModal.close();
      },
      (error) => {
        console.error("Error creating part:", error);
        alert('Error while creating part.');
      }
    );
  }






  getdata() {
    this.sourceInfoData = [];
    this.rankedSellersDetails = [];
    let data = {
      "project_id": Number(this.project_id),
      "version_id": Number(this.version_id),
      "internalPartNo": String(this.internalPartNo),
    };

    console.log('data', data, this.internalPartNo);
    this.masterService.get_project_part_details_Top_N_Seller(data).subscribe((result: any) => {
      let message = result['message'];
      let data = result['results'];
      console.log('results', result);
      if (data) {
        const project_parts = data[0]?.project_parts;
        console.log('project_parts', project_parts);

        this.projectViewData = project_parts[0].part_details;
        let part_header = project_parts[0].part_header;
        this.part_header = part_header;
        this.criteria = {
          stockAvailability: part_header.stockAvailability === 1,
          leadTime: part_header.leadTime === 1,
          minimumPrice: part_header.minimumPrice === 1,
          authorisedSuppliers: part_header.authorisedSuppliers === 1,
          selectedSuppliers: part_header.suppliers || []
        };
        this.projectQty = part_header?.projectQty;
        this.description = part_header?.description;
        this.leadTimeFromHeader = part_header?.leadTime;
        this.commidityFromHeader = part_header?.commodity;

        // Combine nexar and offline offers and add sourcingType for each
        let combinedOffers: any[] = [];
        const partDetails = data[0].project_parts[0].part_details || [];

        const firstDetail = partDetails?.[0];
        const firstNexarOffer = firstDetail?.Top_N_Sellers?.nexar?.[0];

        this.specification = firstNexarOffer?.specification || '';

        partDetails.forEach(detail => {
          const onlineOffers = detail.Top_N_Sellers?.nexar || [];
          onlineOffers.forEach(offer => {
            combinedOffers.push({ ...offer, sourcingType: 'nexar' });
          });

          const offlineOffers = detail.Top_N_Sellers?.offline || [];
          offlineOffers.forEach(offer => {
            combinedOffers.push({ ...offer, sourcingType: 'offline' });
          });
          const vendorOffers = detail.Top_N_Sellers?.vendor || [];
          vendorOffers.forEach(offer => {
            combinedOffers.push({ ...offer, sourcingType: 'vendor' });
          });

        });

        // this.sourceInfoData = combinedOffers;
        // this.filteredSourceInfoData = combinedOffers;
        this.sourceInfoData = combinedOffers;        // original
        this.filteredSourceInfoData = [...combinedOffers];

        this.filteredSourceInfoData = this.calculateLandingCosts(this.sourceInfoData);

        let PartInfoDetails = JSON.parse(JSON.stringify(data[0].project_parts[0].part_details));

        let d: any = PartInfoDetails.map((r: any) => {
          delete r.Specs;
          return r;
        });

        this.preparedPartDetails = d
        this.preparedQuery = "Perform a supplier-wise risk assessment and return a table only (no explanation) with columns: Supplier Name, Total Risk Score (out of 10, 1 decimal), and individual contributions from Inventory Risk (25%), Lead Time Risk (20%), Authorization Risk (25%), Price Deviation Risk (15%), Geographic Risk (15%); calculate: (1) Inventory Risk: InventoryLevel >> ProjectQty = Very Low Risk, > ProjectQty = Low Risk, < ProjectQty = High Risk; (2) Lead Time Risk: factoryLeadDays >12 or (0 and estFactoryLeadDays >12) = High Risk, <8 = Low Risk, (0 and <8) = Medium Risk, both 0 = Very High Risk; (3) Authorization Risk: authorized = Low, not authorized = High; (4) Price Deviation: higher deviation from lowest ConvertedPrice = higher risk; (5) Geographic Risk: US/Europe = Low, Singapore/Australia/etc = Medium, China/Israel/APAC = High; (6) Authorized Supplier Count Risk: fewer authorized suppliers = higher risk; output format must be exact: | Supplier Name | Total Risk Score | Inventory Risk | Lead Time Risk | Authorization Risk | Price Deviation Risk | Geographic Risk |.i want table border='1' in table element ";


        const currencyConversionRates: { [key: string]: number } = {
          INR: 1,
          USD: 86,
          EUR: 90
        };


        this.filteredSourceInfoData = this.filteredSourceInfoData.map((item: any) => {
          const qty = Math.max(item.Closest_Quantity || 0, this.projectQty || 0);

          // Base Price (INR) calculation
          const basePriceINR = (item.Price || 0) * (item.ConversionRate || 1);

          // Est Landing Cost (from API or calculation)
          const landingCostINR = item.LandingCost || 0;
          const totalLandingCost = (landingCostINR / (item.ConversionRate || 1)) * qty;

          // Total Est Landing Cost
          const totalEstCost = landingCostINR * qty;

          return {
            ...item,
            BasePriceINR: basePriceINR,
            LandingCost: landingCostINR,
            Total_est_Cost: totalEstCost,
            Total_landing_cost: totalLandingCost

          };
        });


        let manufacturer: any = [];
        for (let index = 0; index < this.sourceInfoData.length; index++) {
          manufacturer.push(this.sourceInfoData[index]['manufacturer']);
          this.manufacturerDetails = manufacturer;
          this.manufacturerDetails = Array.from(new Set(manufacturer));

        }

        // Carry on with your existing risk analysis, calculations and other logic as needed...

        console.log('this.projectViewData', this.projectViewData);
      } else {
        console.error('Error: Unable to retrieve project data');
        this.errorMessage = 'There was an issue retrieving the project data. Please try again.';
      }
    });
  }
  calculateLandingCosts(data: any[]) {
    return data.map((item: any) => {
      const qty = Math.max(item.Closest_Quantity || 0, this.projectQty || 0);

      const conversionRate = item.ConversionRate || 1;
      const landingCostINR = item.LandingCost || 0;

      return {
        ...item,
        BasePriceINR: (item.Price || 0) * conversionRate,
        Total_est_Cost: landingCostINR * qty,
        Total_landing_cost: (landingCostINR / conversionRate) * qty
      };
    });
  }

  openDatasheet(supplierData: any) {
    // Use the datasheetURL or clickUrl field; fallback to null check
    const url = supplierData.DatasheetURL;
    if (url) {
      window.open(url, '_blank');
    } else {
      console.warn('No datasheet URL available for supplier:', supplierData.supplier);
    }
  }

  callAnalyzeHtml() {
    if (!this.preparedPartDetails.length || !this.preparedQuery) {
      console.error('Analyze HTML payload not ready.');
      return;
    }

    const payload = {
      data: this.preparedPartDetails,
      query: this.preparedQuery
    };

    this.masterService.analyze_html(payload).subscribe(
      (res: any) => {
        this.cleanedResHTML = res?.html?.replace(/\n/g, '') || '';
        this.showPopup = true;

        setTimeout(() => {
          const container = document.querySelector('#risk-analysis-table');
          const table = container?.querySelector('table');

          if (!table) return;

          const rows = table.querySelectorAll('tbody tr');
          rows.forEach((row: any) => {
            const cells = row.querySelectorAll('td');
            if (cells.length > 1) {
              const scoreCell = cells[1]; // "Total Risk Score" column
              const score = parseFloat(scoreCell.innerText);
              if (!isNaN(score)) {
                const dot = document.createElement('span');
                dot.style.display = 'inline-block';
                dot.style.width = '10px';
                dot.style.height = '10px';
                dot.style.borderRadius = '50%';
                dot.style.marginLeft = '8px';
                dot.style.verticalAlign = 'middle';

                if (score < 4) {
                  dot.style.backgroundColor = 'green';
                } else if (score <= 5.5) {
                  dot.style.backgroundColor = 'orange';
                } else {
                  dot.style.backgroundColor = 'red';
                }

                dot.title = `Risk Score: ${score}`;
                scoreCell.appendChild(dot);

                scoreCell.style.backgroundColor = 'transparent';
                scoreCell.style.color = 'black';
              }
            }
          });
        }, 100);

      },
      error => {
        console.error('analyze_html API error:', error);
      }
    );
  }


  onCardClick() {
    // this.cleanedResHTML = '';  
    this.callAnalyzeHtml();
    this.showPopup = true;
    // this.Indicator();
  }

  closePopup() {
    this.showPopup = false;

  }


  refreshPage() {
    this.selectedManufacturer = '';
    this.mpnMatch = this.sessionMpnMatch;
    this.getdata();
  }

  openDataSheet() {
    if (this.dataSheet) {
      window.open(this.dataSheet, '_blank'); // Opens in a new tab
    }
  }

  home() {

    if (this.userRole === 'Engineer') {
      this.router.navigate(['/dashboard-engineer'])
    }
    else if (this.userRole === 'Manager' || this.userRole === 'Admin') {
      this.router.navigate(['/dashboard-manager'])
    }
  }

  back() {
    console.log("Sending Back Filter From Part-Info:", this.savedFilter);
    if (this.userRole === 'Engineer') {
      let state: any = history.state
      this.router.navigate(['/project-view'], {
        state: {

          startIndex: state?.startIndex ?? 0,
          endIndex: state?.endIndex ?? 10,
          rowsPerPage: state ? state.rowsPerPage : 10,
          currentPage: !!state ? state?.currentPage : 1,

          customerInfo: this.customerInfoData,
          detectPartInfo: true,
          savedFilter: this.savedFilter
        }
      })
    }
    else if (this.userRole === 'Manager' || this.userRole === 'Admin') {
      let state: any = history.state
      this.router.navigate(['/project-view'], {
        state: {
          startIndex: state?.startIndex ?? 0,
          endIndex: state?.endIndex ?? 10,
          rowsPerPage: state ? state.rowsPerPage : 10,
          currentPage: !!state ? state?.currentPage : 1,
          customerInfo: this.customerInfoData,
          detectPartInfo: true,
          savedFilter: this.savedFilter
        }
      })
    }
  }


  onManufacturerChange() {

    const currencyConversionRates: { [key: string]: number } = {
      INR: 1,
      USD: 86,
      EUR: 90
    };

    let filteredData: any[] = [];

    if (this.selectedManufacturer) {
      filteredData = this.sourceInfoData.filter(
        (item: any) => item.manufacturer === this.selectedManufacturer
      );

      this.mpnMatch = filteredData.length > 0 ? filteredData[0].MPN : 'N/A';
    } else {
      filteredData = [...this.sourceInfoData];
      this.mpnMatch = '';
    }

    //  IMPORTANT: Recalculate Landing Cost & Totals after filter
    this.filteredSourceInfoData = filteredData.map((item: any) => {
      const qty = Math.max(item.Closest_Quantity || 0, this.projectQty || 0);
      const conversionRate = item.ConversionRate || 1;
      const landingCostINR = item.LandingCost || 0;

      return {
        ...item,
        BasePriceINR: (item.Price || 0) * conversionRate,
        Total_est_Cost: landingCostINR * qty,
        Total_landing_cost: (landingCostINR / conversionRate) * qty
      };
    });
  }

  exportData(): void {
    this.exportService.exportToExcel(this.filteredSourceInfoData, `${this.internalPartNo}-PartInfo.xlsx`, `${this.internalPartNo}-PartInfo`);
  }

  selectRow(index: number) {
    this.selectedRowIndex = this.selectedRowIndex === index ? null : index; // Toggle selection
  }


  onClickOfferPrice(offerPriceModal, selectedData: any) {
    this.offerPriceListDetails = [];
    this.selectedSupplierData = null;

    if (selectedData.sourcingType === 'offline') {
      this.tempOfflineData = { ...selectedData };
      this.offlineConfirmModalRef = this.modalService.open(this.offlineConfirmModal, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'sm',
        centered: true,
        backdrop: 'static'
      });
      return;
    }

    // Open modal immediately for current row
    this.modalRef = this.modalService.open(offerPriceModal, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md'
    });

    const requestData = {
      project_id: Number(this.project_id),
      version_id: Number(this.version_id),
      projectQty: this.projectQty,
      specification: selectedData.specification,
      MPN: selectedData.MPN,
      manufacturer: selectedData.manufacturer,
      supplier: selectedData.supplier,
      source: selectedData.sourcingType,
    };

    // keep local reference to avoid override by out-of-order responses
    const clickedMPN = selectedData.MPN;

    this.masterService.get_offer_price(requestData).subscribe(
      (result) => {
        // if user already clicked another row, ignore this response
        if (!this.modalRef || clickedMPN !== selectedData.MPN) {
          return;
        }

        const responseData = result['results']?.[0];

        if (responseData) {
          this.offerPriceListDetails = responseData.prices || [];
          const currency = responseData.prices?.[0]?.currency;

          this.selectedSupplierData = {
            ...selectedData,
            companyName: responseData.companyName,
            stored_at: responseData.stored_at,
            currency: currency,
            LandingCost: selectedData.LandingCost
          };
        } else {
          this.offerPriceListDetails = [];
        }
      },
      (error) => {
        console.error('Error fetching offer price:', error);
        this.notify.danger('Failed to fetch offer price', 'Error');
        this.offerPriceListDetails = [];
      }
    );
  }


  confirmOfflineUpdate() {
    // Close confirmation modal
    if (this.offlineConfirmModalRef) {
      this.offlineConfirmModalRef.close();
    }

    // Prepare data from tempOfflineData
    this.selectedSupplierData = {
      ...this.tempOfflineData,
      companyName: this.tempOfflineData.supplier || '',
      stored_at: new Date().toISOString(),
      currency: this.tempOfflineData.Currency || 'INR',
      LandingCost: this.tempOfflineData.LandingCost
    };

    // Prepare selectedPriceData with offline data
    this.selectedPriceData = {
      quantity: this.tempOfflineData.Closest_Quantity || this.tempOfflineData.MOQ || 0,
      price: this.tempOfflineData.Price || 0,
      currency: this.tempOfflineData.Currency || 'INR'
    };

    // Call save API
    this.savePriceDataOffline();

    // Clear temp data
    this.tempOfflineData = null;
  }



  // selectPriceRow(index: number) {
  //   this.selectedPriceRowIndex = this.selectedPriceRowIndex === index ? null : index; // Toggle selection
  //   this.selectedPriceData = this.offerPriceListDetails[index]; // Store the selected object

  //   console.log('offerPriceDetails', this.selectedPriceData)
  // }

  selectPriceRow(index: number) {
    // Same row ni uncheck chesthe
    if (this.selectedPriceRowIndex === index) {
      this.selectedPriceRowIndex = null;
      this.selectedPriceData = null;
    } else {
      this.selectedPriceRowIndex = index;
      this.selectedPriceData = this.offerPriceListDetails[index];
    }
  }




  savePriceData() {
    console.log("this.selectedSupplierData => ", this.selectedSupplierData);

    let obj = {
      "project_id": Number(this.project_id),
      "version_id": Number(this.version_id),
      "MPN": this.selectedSupplierData.MPN,
      "Inventorylevel": this.selectedSupplierData.Inventorylevel,
      "estimatedFactoryLeadDays": this.selectedSupplierData.estimatedFactoryLeadDays,
      "MOQ": this.selectedSupplierData.MOQ ? this.selectedSupplierData.MOQ : this.selectedPriceData.quantity,
      "TotalAvail": this.selectedSupplierData.TotalAvail,
      "Closest_Quantity": this.selectedPriceData.quantity,
      "Price": this.selectedPriceData.price,
      "Currency": this.selectedPriceData.currency,
      "country": this.selectedSupplierData.country,
      "ConvertedCurrency": this.selectedSupplierData.ConvertedCurrency || "INR",
      "ConversionRate": this.selectedSupplierData.ConversionRate,
      "ConvertedPrice": this.selectedSupplierData.ConvertedPrice,
      "Manufacturer_ID": this.selectedSupplierData.Manufacturer_ID,
      "manufacturer": this.selectedSupplierData.manufacturer,
      "supplier": this.selectedSupplierData.supplier,
      "Seller_ID": this.selectedSupplierData.Seller_ID,
      "Manufacturer_IsVerified": this.selectedSupplierData.Manufacturer_IsVerified,
      "DatasheetURL": this.selectedSupplierData?.DatasheetURL || "",
      "QuantityDiff": this.selectedSupplierData.QuantityDiff,
      "Rank_id": this.selectedSupplierData.Rank,
      "BestSeller": "Yes",
      "stockAvailability": this.selectedSupplierData.Inventorylevel,
      "internalPartNo": sessionStorage.getItem('internalPartNo'),
      "landing_cost": Math.round(this.selectedSupplierData?.LandingCost ?? 0),
      "IsSourced": 1,
      "sourcingType": this.selectedSupplierData.sourcingType || 'nexar'
    };

    console.log("Savepayload => ", obj);

    this.masterService.update_Finalise_project_part(obj).subscribe(
      (res: any) => {
        console.log('res in updated project', res);

        // Close modal only if it was opened (for nexar/vendor)
        if (this.modalRef) {
          this.modalRef.close();
        }
        this.modalService.dismissAll();

        // Show success notification
        this.notify.success('Part finalized successfully', 'Success');
        let state: any = history.state
        // Navigate back to project view
        this.router.navigate(['/project-view'], {
          state: {
            customerInfo: this.customerInfoData,
            detectPartInfo: true,
            highlightedIPN: this.internalPartNo,
            startIndex: state?.startIndex ?? 0,
            endIndex: state?.endIndex ?? 10,
            rowsPerPage: state ? state.rowsPerPage : 10,
            currentPage: !!state ? state?.currentPage : 1,

          }
        });
      },
      (error) => {
        console.error('Error updating project part:', error);
        this.notify.danger('Failed to finalize part', 'Error');
      }
    );
  }
  savePriceDataOffline() {
    if (!this.selectedPriceData || !this.selectedSupplierData) {
      console.error("No selected data found to save.");
      return;
    }

    const qty = Number(this.selectedPriceData.quantity) || 1;
    const price = Number(this.selectedPriceData.price) || 0;


    let obj = {
      project_id: Number(this.project_id),
      version_id: Number(this.version_id),
      MPN: this.selectedSupplierData.MPN || "",
      supplier: this.selectedSupplierData.supplier || "",
      Currency: this.selectedPriceData.currency || 'INR',
      MOQ:this.selectedSupplierData.MOQ,
      Closest_Quantity: this.selectedSupplierData.Closest_Quantity,
      Price: price,
      landing_cost: Math.round(this.selectedSupplierData?.LandingCost ?? 0),
      internalPartNo: this.internalPartNo || "",
      Inventorylevel: 0,
      estimatedFactoryLeadDays: Number(this.selectedSupplierData.estimatedFactoryLeadDays).toFixed(2),
      TotalAvail: 0,
      country: "IN",
      ConvertedCurrency: this.selectedSupplierData.ConvertedCurrency || "INR",
      ConversionRate: this.selectedSupplierData.ConversionRate,
      ConvertedPrice: Number(this.selectedSupplierData.ConvertedPrice).toFixed(2),
      Manufacturer_ID: "0",
      manufacturer: this.selectedSupplierData.manufacturer,
      Seller_ID: "0",
      Manufacturer_IsVerified: true,
      DatasheetURL: "",
      QuantityDiff: 0,
      Rank_id: 0,
      BestSeller: "Yes",
      stockAvailability: 0,
      "IsSourced": 1,
      sourcingType: this.selectedSupplierData.sourcingType || 'offline'
    };

    console.log("Save payload => ", obj);
    this.masterService.update_Finalise_project_part(obj).subscribe(
      (res: any) => {
        console.log('res in updated project', res);
        if (this.modalRef) {
          this.modalRef.close();
        }
        this.modalService.dismissAll();
        let customerInfo: any = structuredClone(this.customerInfoData);
        console.log("customerInfo => ", customerInfo);
        this.notify.success('Part finalized successfully', 'Success');
        let state: any = history.state
        this.router.navigate(['/project-view'], {
          state: {
            customerInfo: this.customerInfoData,
            detectPartInfo: true,
            highlightedIPN: this.internalPartNo,
            startIndex: state?.startIndex ?? 0,
            endIndex: state?.endIndex ?? 10,
            rowsPerPage: state ? state.rowsPerPage : 10,
            currentPage: !!state ? state?.currentPage : 1,
          }
        });
      },
      (error) => {
        console.error('Error updating project part:', error);
        this.notify.danger('Failed to finalize part', 'Error');
      }
    );

  }



  savePriceDataPriceHistory() {
    if (!this.selectedPriceData || !this.selectedSupplierData) {
      console.error("No selected data found to save.");
      return;
    }

    const qty = Number(this.selectedPriceData.quantity) || 1;
    const price = Number(this.selectedPriceData.price) || 0;
    const convertedPrice = Number(this.selectedPriceData.convertedPrice) || 0;
    const landingCost = Number(this.selectedPriceData.landing_INR_cost) || 0;
    let obj = {
      project_id: Number(this.project_id),
      version_id: Number(this.version_id),
      MPN: this.selectedSupplierData.MPN || "",
      supplier: this.selectedSupplierData.supplier || "",
      Currency: this.selectedPriceData.currency || 'INR',
      MOQ: 1,
      Closest_Quantity: 1,
      Price: price,
      landing_cost: Math.round(landingCost),
      internalPartNo: this.internalPartNo || "",
      Inventorylevel: 0,
      estimatedFactoryLeadDays: 42,
      TotalAvail: 0,
      country: "IN",
      ConvertedCurrency: "INR",
      ConversionRate: 0,
      ConvertedPrice: convertedPrice,
      Manufacturer_ID: "0",
      manufacturer: "No Info",
      Seller_ID: "0",
      Manufacturer_IsVerified: true,
      DatasheetURL: "",
      QuantityDiff: 0,
      Rank_id: 0,
      BestSeller: "Yes",
      stockAvailability: 0,
      "IsSourced": 1,
      sourcingType: this.selectedSupplierData.sourcingType || 'offline'
    };

    console.log("Save payload => ", obj);

    this.masterService.update_Finalise_project_part(obj).subscribe(
      (res: any) => {
        console.log('res in updated project', res);

        if (this.modalRef) {
          this.modalRef.close();
        }
        this.modalService.dismissAll();
        let customerInfo: any = structuredClone(this.customerInfoData);
        console.log("customerInfo => ", customerInfo);
        this.notify.success('Part finalized successfully', 'Success');
        let state: any = history.state
        this.router.navigate(['/project-view'], {
          state: {
            customerInfo: this.customerInfoData,
            detectPartInfo: true,
            highlightedIPN: this.internalPartNo,
            startIndex: state?.startIndex ?? 0,
            endIndex: state?.endIndex ?? 10,
            rowsPerPage: state ? state.rowsPerPage : 10,
            currentPage: !!state ? state?.currentPage : 1,
          }
        });
      },
      (error) => {
        console.error('Error updating project part:', error);
        this.notify.danger('Failed to finalize part', 'Error');
      }
    );
  }

  closeModal() {

    if (this.modalRef) {
      this.modalRef.close();
    }
    this.modalService.dismissAll();
  }
  getUnitsName(specs: any[], specName: string): string {
    const spec = specs?.find(s => s.name === specName);
    return spec?.unitsName || '';
  }
  selectCriteria(criteriaModal) {
    console.log('Criteria selected');

    this.modalRef = this.modalService.open(criteriaModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }), this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }



  specificationDetails(partDetails: any) {
    if (partDetails && partDetails.Specs) {
      this.selectedSpecs = partDetails.Specs;
      this.showSpecsDetails = true;
    } else {
      this.selectedSpecs = [];
      this.showSpecsDetails = false;
    }
  }

  closeSpecificationDetails() {
    this.showSpecsDetails = false;
    this.selectedSpecs = [];
  }

  priceSummary: any;
  selectedPriceHistory: any[] = [];

  closePriceHistory() {
    this.showPopup1 = false;

    let state: any = history.state

    if (this.cameFrom === 'project-view') {
      this.router.navigate(
        ['/project-view'],
        {
          state: {
            startIndex: state?.startIndex ?? 0,
            endIndex: state?.endIndex ?? 10,
            rowsPerPage: state?.rowsPerPage ?? 10,
            currentPage: state?.currentPage ?? 1
          }
        }
      );
    }
  }



  getProcurementHistory() {
    if (!this.internalPartNo) {
      console.error("Internal Part Number not found in sessionStorage");
      return;
    }

    this.masterService.getPartPriceHistoryInternal(
      this.internalPartNo,
      this.project_id,
      this.version_id,
      this.commodity
    ).subscribe({
      next: (response: any) => {

        if (!response || !response.parts || response.parts.length === 0) {
          this.infoMessage = 'Procurement history not available';
          this.showPopup1 = false;
          return;
        }
        this.priceSummary = {
          internalPartNumber: response.internalPartNumber,
          minPriceINR: response.minLandingPriceINR,
          maxPriceINR: response.maxLandingPriceINR,
          purchaseCount: response.purchaseCount,
          weightedAveragePriceINR: response.weightedAveragePriceINR,
          projectQty: this.projectQty
        };

        this.selectedPriceHistory = response.parts;
        console.log("Selected Price History:", this.selectedPriceHistory);

        this.showPopup1 = true;
      },
      error: (err) => {
        console.error('Error fetching price history', err);
        this.showPopup1 = false;
        this.showInfoToast('Procurement history not available');
      }
    });
  }
  infoMessage: string = '';

  showInfoToast(message: string) {
    this.notify.info(message);
  }

  selectedHistory: any[] = [];
  showSendButton: boolean = false;



  // onSelectHistory(selectedRow: any) {

  //   // Unselect all rows first
  //   this.selectedPriceHistory.forEach(r => {
  //     if (r !== selectedRow) {
  //       r.isSelected = false;
  //     }
  //   });

  //   // Toggle the clicked row ON
  //   selectedRow.isSelected = true;

  //   // Store only that one row
  //   this.selectedHistory = [selectedRow];

  //   // Show button
  //   this.showSendButton = true;
  // }

  onSelectHistory(selectedRow: any) {

    if (selectedRow.isSelected) {

      this.selectedPriceHistory.forEach(r => {
        if (r !== selectedRow) {
          r.isSelected = false;
        }
      });

      this.selectedHistory = [selectedRow];

      this.showSendButton = true;

    } else {
      this.selectedHistory = [];
      this.showSendButton = false;
    }
  }

  sendSelectedHistory() {
    if (!this.selectedHistory || this.selectedHistory.length === 0) {
      return;
    }

    const selectedRow = this.selectedHistory[this.selectedHistory.length - 1];

    this.selectedSupplierData = {
      supplier: selectedRow.supplierName,
      MPN: selectedRow.mpn,
      ConvertedCurrency: selectedRow.currency || 'INR',
      sourcingType: 'offline'
    };

    // Assign values to selectedPriceData
    this.selectedPriceData = {
      quantity: selectedRow.qty,
      price: selectedRow.unitPrice,
      currency: selectedRow.currency || 'INR',
      convertedPrice: selectedRow.unitPriceINR,
      landing_INR_cost: selectedRow.landing_INR_cost

    };
    this.showPopup1 = false;

    // Call your existing save
    this.savePriceDataPriceHistory();
  }



  onSort(column: string) {
    if (this.sortColumn === column) {

      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.selectedPriceHistory.sort((a, b) => {
      let aValue = a[column];
      let bValue = b[column];

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (aValue < bValue) return this.sortDirection === 'asc' ? -1 : 1;
      if (aValue > bValue) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }


}
